import React from 'react';
import { Box, Button, Grid, Paper, Stack, TextField, Typography } from '@mui/material';
import RefreshIcon from '@mui/icons-material/Refresh';
import AddIcon from '@mui/icons-material/Add';
import SendIcon from '@mui/icons-material/Send';
import GavelIcon from '@mui/icons-material/Gavel';

type Props = {
  fiscalYear: string; status: string; budgetVersionId: number | ''; ppmId: number | '';
  packageTitle: string; meetingDate: string; meetingReference: string; notes: string;
  selected: any | null; loading?: boolean;
  onChange: (name: string, value: any) => void;
  onRefresh: () => void; onCreatePackage: () => void; onSubmitPackage: () => void; onRecordDecision: () => void;
};

class CAReviewFilterBar extends React.Component<Props> {
  render() {
    const p = this.props;
    const change = (name:string) => (e:any) => p.onChange(name, e.target.value);

    return (
      <Paper elevation={1} sx={{p:2, mb:3}}>
        <Stack direction={{xs:'column', md:'row'}} justifyContent="space-between" alignItems={{xs:'stretch', md:'center'}} spacing={2} sx={{mb:2}}>
          <Box>
            <Typography variant="subtitle1" sx={{fontWeight:700}}>CA Review Controls</Typography>
            <Typography variant="caption" color="text.secondary">Create CA packages, submit for review, and record external decisions.</Typography>
          </Box>
          <Stack direction="row" spacing={1} flexWrap="wrap">
            <Button variant="outlined" startIcon={<RefreshIcon />} onClick={p.onRefresh} disabled={p.loading}>Refresh</Button>
            <Button variant="outlined" startIcon={<AddIcon />} onClick={p.onCreatePackage} disabled={p.loading || !p.budgetVersionId}>Create Package</Button>
            <Button variant="outlined" startIcon={<SendIcon />} onClick={p.onSubmitPackage} disabled={p.loading || !p.selected}>Submit</Button>
            <Button variant="contained" startIcon={<GavelIcon />} onClick={p.onRecordDecision} disabled={p.loading || !p.selected}>Record Decision</Button>
          </Stack>
        </Stack>
        <Grid container spacing={2}>
          <Grid size={{xs:12, md:1.5}}><TextField size="small" label="Year" value={p.fiscalYear} onChange={change('fiscalYear')} fullWidth /></Grid>
          <Grid size={{xs:12, md:1.5}}><TextField size="small" label="Status" value={p.status} onChange={(e)=>p.onChange('status', e.target.value.toUpperCase())} fullWidth /></Grid>
          <Grid size={{xs:12, md:2}}><TextField size="small" type="number" label="Budget Version ID" value={p.budgetVersionId} onChange={(e)=>p.onChange('budgetVersionId', e.target.value===''?'':Number(e.target.value))} fullWidth /></Grid>
          <Grid size={{xs:12, md:2}}><TextField size="small" type="number" label="PPM ID" value={p.ppmId} onChange={(e)=>p.onChange('ppmId', e.target.value===''?'':Number(e.target.value))} fullWidth /></Grid>
          <Grid size={{xs:12, md:3}}><TextField size="small" label="Package Title" value={p.packageTitle} onChange={change('packageTitle')} fullWidth /></Grid>
          <Grid size={{xs:12, md:2}}><TextField size="small" type="date" label="Meeting Date" value={p.meetingDate} onChange={change('meetingDate')} fullWidth InputLabelProps={{shrink:true}} /></Grid>
          <Grid size={{xs:12, md:3}}><TextField size="small" label="Meeting Reference" value={p.meetingReference} onChange={change('meetingReference')} fullWidth /></Grid>
          <Grid size={{xs:12, md:9}}><TextField size="small" label="Notes" value={p.notes} onChange={change('notes')} fullWidth /></Grid>
        </Grid>
      </Paper>
    );
  }
}
export default CAReviewFilterBar;
